import { useNewBookingStore } from '../../../../../domain/booking/stores/useNewBookingsStore';

export function useIsSelected(id: number) {
	const store = useNewBookingStore();

	return store.booking.parkingProduct?.id === id;
}
